import { User } from '@models';

export interface CurrentUserResult {
  currentUser: User;
}
